export const classes = {
  list: 'list-disc list-inside pl-4 py-4 text-base md:text-lg text-grey-8',
  sublist: 'pl-8 pt-2',
};
